module.exports = __webpack_public_path__ + "static/media/tap2-hover-back.6f4bd69f.svg";